import {
  FETCH_COVERED_IN_CLASS_CONTENT_SUCCESS,
  CHANGE_COVERED_IN_CLASS_OBJECT,
  RESET_COVERED_IN_CLASS_OBJECT,
} from './actions';
import { Map, List } from 'immutable';
import CoveredInClass from './model';

export default function coveredInClassContent(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_COVERED_IN_CLASS_CONTENT_SUCCESS: {
      if (! action.payload) {
        // no CIC content for session. this will show the "No content" message in the component.
        return state.set(action.sessionId, null);
      }
      return state.set(action.sessionId, onSuccess(state, action));
    }
    case CHANGE_COVERED_IN_CLASS_OBJECT:
      return state.set(action.sessionId, action.payload);
    case RESET_COVERED_IN_CLASS_OBJECT:
      return resetCICBySessionId(state, action.sessionId);
    default:
      return state;
  }
}

function onSuccess(state, action) {
  return action.payload.reduce((map, coveredInClass) =>
    map.set(`${coveredInClass.unitId}-${coveredInClass.lessonNumber}`, CoveredInClass.create(coveredInClass)), new Map());
}

function resetCICBySessionId(state, sessionId) {
  return state.set(sessionId, state.get(sessionId).map((cic) =>
      cic.set('cicActivities', new List())
        .set('cicCategories', new List())));
}



// WEBPACK FOOTER //
// ./data/CoveredInClass/reducer.js